import { render } from "./onboarding-template.vue?vue&type=template&id=682753c4&scoped=true"
import script from "./onboarding-template.vue?vue&type=script&lang=js"
export * from "./onboarding-template.vue?vue&type=script&lang=js"

import "./onboarding-template.vue?vue&type=style&index=0&id=682753c4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682753c4"]])

export default __exports__